import React, { useEffect, useState } from 'react';
import { Marker, Popup } from 'react-leaflet';
import api from '../../config/api';
import { distanceNm, bearingDeg } from './MobControl';
import PoiDetailsContent from './PoiDetailsContent';

/**
 * Map marker for a place picked from search — loads phone/VHF via poi-details API.
 */
export default function SearchPlaceMarker({ target, vesselPosition, onClose }) {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!target?.latitude || !target?.longitude) return;
    let cancelled = false;
    setLoading(true);
    setDetails(null);

    (async () => {
      try {
        const params = { lat: target.latitude, lon: target.longitude };
        if (target.acId) params.acId = target.acId;
        const resp = await api.get('/api/geo/poi-details', { params });
        if (!cancelled) setDetails(resp.data || {});
      } catch {
        if (!cancelled) setDetails({});
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => { cancelled = true; };
  }, [target?.latitude, target?.longitude, target?.acId]);

  if (!target) return null;

  const extra = details || {};
  const dist = vesselPosition
    ? distanceNm(vesselPosition.latitude, vesselPosition.longitude, target.latitude, target.longitude)
    : null;
  const brg = vesselPosition
    ? bearingDeg(vesselPosition.latitude, vesselPosition.longitude, target.latitude, target.longitude)
    : null;

  return (
    <Marker position={[target.latitude, target.longitude]}>
      <Popup>
        <PoiDetailsContent
          name={target.name || extra.name}
          categoryLabel={target.type ? String(target.type).replace('marine-', '').replace(/-/g, ' ') : null}
          address={extra.address}
          phone={extra.phone || target.phone}
          website={extra.website || target.url}
          vhf={extra.vhf}
          notes={extra.notes}
          rating={target.rating}
          extraRating={extra.rating}
          distanceNm={dist}
          bearingDeg={brg}
          loading={loading}
          unavailable={!loading && details !== null}
        />
        <button
          type="button"
          style={{ marginTop: 8, cursor: 'pointer', fontSize: '0.8rem' }}
          onClick={onClose}
        >
          Remove marker
        </button>
      </Popup>
    </Marker>
  );
}
